"use client"

import { flightActions } from "@/lib/redux/features/flight/reduce"
import { useLayoutEffect } from "react"
import { storeRef } from "../providers/StoreProvider"

const AirportsContainer = ({ children, airports }: any) => {
  // Do not dispatch during render — that updates FormSearchFlightSkeleton mid-render.
  useLayoutEffect(() => {
    if (!airports) return
    storeRef?.current?.dispatch(flightActions.setAirportData(airports))
  }, [airports])

  return children
}

export default AirportsContainer
